import React from 'react';
import styles from 'componets/light-box/index.module.scss';
import Button from 'componets/button';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const LightBox = ({ show = false, title, content, onCancel, onApprove, loading = false, approveText = '確認移除' }) => {
  const mask = cx({
    mask: true,
    show: show,
    hide: !show,
  });

  const cancel = () => {
    if (onCancel) {
      onCancel();
    }
  };

  const approve = () => {
    if (onApprove) {
      onApprove();
    }
  };

  return (
    <div className={mask}>
      <div className={styles.box}>
        <div className={styles.boxTitle}>{title}</div>
        <div className={styles.boxContent}>{content}</div>
        <div className={styles.boxButton}>
          <Button variant="text" onClick={cancel}>
            取消
          </Button>
          <Button onClick={approve} loading={loading}>
            {approveText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LightBox;
